import $ from 'jquery';

require('jquery.cookie');

interface IPopupOptions {
  show: {web: {s: boolean; m: boolean; l: boolean}};
  cookie: string;
  delay: number;
  once: boolean;
  expiry: number;
}

export class SitePopup {
  public static frontend(el: HTMLElement, opt: any) {
    return new this($(el), opt);
  }

  constructor(public $elem: JQuery, public opt: IPopupOptions, updateHook?) {
    const w = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0,
    );
    if (
      (w <= 640 && opt.show.web.s) ||
      (w <= 1024 && w > 640 && opt.show.web.m) ||
      (w > 1024 && opt.show.web.l)
    ) {
      if (!$.cookie(`sitePopup${opt.cookie}`)) {
        const delay = Math.max(opt.delay * 1000, 3000);
        document.onreadystatechange = () => {
          if (document.readyState === 'complete') {
            setTimeout(() => {
              $elem.find('a').trigger('click', [opt.once, opt.expiry]);
            }, delay);
          }
        };
      }
    }
  }
}
